<template>
  <div class="empty-wrapper">
    <img
      class="dh-img"
      :src="emptyUrl"
      alt=""
    />
    <!--文本为：暂无机型喔！-->
    <p>{{ $t('PCProduct.empty') }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    emptyUrl() {
      return require(`@/assets/image/product/empty.png`);
    },
  },
};
</script>

<style lang="less" scoped>
.empty-wrapper {
  text-align: center;
  position: fixed;
  top: 60%;
  left: 62%;
  transform: translate(-50%, -50%);
  // right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  img {
    width: 320px;
    height: 320px;
  }
  .dh-img {
    width: 320px;
    height: 320px;
  }
  p {
    font-size: 32px;
    color: #252629;
  }
}
</style>
